export default __webpack_public_path__ + "static/home2-1667f34f3fb83acf8442b6407944b993.jpg";